module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_common_new_communication_widget-bc8f7a958eee0e022c6b2eb41fab3522.png";